<template>
  <div class="step-plus-one">
    <div class="step-content">
      <ProgressBar progress="50" label="2 / 4" />

      <div v-if="id && name">
        <div class="d-flex mt-5 flex-sm-column-reverse align-items-sm-center">
          <div>
            <img :src="imagePaymentLogo" class="mx-2 mr-3 mt-sm-2 w-100" style="max-width: 70px" alt="" />
          </div>
          <h1 v-html="textPaymentMethod" class="pt-sm-2 mx-2 text-sm-center"></h1>
        </div>

        <h2 class="text-sm-center">
          <span>{{ textOrderBonus }}:</span> {{ textGetToday }}
        </h2>

        <div class="features-container">
          <!-- <div v-html="plusoneText" class="features-container__description mb-3"></div> -->
          <div class="pb-3 text-center">
            <div v-html="getProductImageHtml()" class="features-container__image mx-auto"></div>
          </div>
        </div>

        <div class="timer-title text-center mt-4 mb-4">
          <img :src="imageTimer" class="mr-2" width="25" alt="" />
          {{ textLimitedTime }}:
        </div>

        <div class="d-sm-flex">
          <div class="red-button mx-auto my-2" @click="addProduct(1)" :is-loading="isLoading || !upsellPrices['1']">
            {{ yesText }}! {{ iWantText }} 1 {{ name }} {{ toMyOrderTextText }} {{ upsellPrices["1"] && upsellPrices["1"].price_text }}
          </div>
        </div>
      </div>
      <div v-else class="text-center m-5">
        <Spinner />
      </div>

      <p class="no">
        <a @click="$emit('skip')">
          {{ textCancel }}
        </a>
      </p>
    </div>
  </div>
</template>

<script>
import { t } from "../../utils/i18n";
import upsells from "../../mixins/upsells";
import { getUppSells } from "../../services/upsells";
import Spinner from "../common/preloaders/Spinner";
import ProgressBar from "./ProgressBar";

export default {
  name: "StepPlusOne",

  mixins: [upsells],

  props: ["id", "discount", "accessoryStep"],

  components: { Spinner, ProgressBar },

  data: () => ({
    upsellPrices: {},
    description: null,
    finalPrice: null,
    finalPricePure: null,
    name: null,
    productName: null,
    price: null,
    priceFormatted: null,
    imageUrl: null,
    gifImageUrl: null,
    vimeoId: null,
    videoFile: null,
    plusoneText: null,
    isLoading: false
  }),

  computed: {
    congratulationsText: () => t("upsells.congratulations"),
    customerNumberText: () => t("upsells.customer_number"),
    thankYouText: () => t("upsells.thank_you"),
    forText: () => t("upsells.for"),
    offText: () => t("upsells.off"),
    yesText: () => t("upsells.yes"),
    iWantText: () => t("upsells.want_add"),
    toMyOrderTextText: () => t("upsells.to_order"),
    textCancel: () => t("upsells.cancel.full"),
    textLimitedTime: () => t("upsells.limited_time_offer"),
    textPeopleSaying: () => t("upsells.people_saying"),
    textVerifiedBuyer: () => t("reviews.verified"),
    textMastercardCustomer: () => t("upsell.mastercard_customers"),
    textOrderBonus: () => t("upsell.order_bonus"),

    textWaitCustomer() {
      return this.$t("upsells.wait_customer", { NAME: js_data.order_customer.customer_first_name || localStorage.getItem("stripe_username") || '' });
    },
    textGetToday() {
      return this.$t("upsell.get_today_only", { PRODUCT: this.name, PRICE: this.upsellPrices ? this.upsellPrices["1"].price_text : "" });
    },
    textCustomersReviews() {
      return this.$t("upsells.customers_reviews", { PRODUCT: this.name });
    },

    textPaymentMethod() {
      return this.$t("upsell.mastercard_customers", { PAYMENT: js_data.payment_method.name });
    },

    imageFeatureCheck() {
      return this.$root.cdn_url + "/assets/images/upsells/check-circle-green.svg";
    },
    imageTimer() {
      return this.$root.cdn_url + "/assets/images/upsells/timer.svg";
    },
    image5star() {
      return this.$root.cdn_url + "/assets/images/zmc10/5star.svg";
    },
    imagePaymentLogo() {
      return js_data.payment_method.logo;
    },

    // process HTML description to pull features highlights
    headerFeatures() {
      var features = [];
      var el = document.createElement("html");
      el.innerHTML = this.description;
      for (let li of el.getElementsByTagName("li")) {
        features.push(li.innerHTML);
      }
      return features;
    }
  },

  mounted() {
    this.isLoading = true;

    if (!this.id) {
      return;
    }

    getUppSells(this.id, this.getAllowedUpsellQty() || 1, this.accessoryStep)
      .then(res => {
        if (res && res.data) {
          if (res.data.upsell) {
            this.upsellPrices = res.data.upsell.upsellPrices;
            this.name = res.data.upsell.long_name;
            this.productName = res.data.upsell.product_name;
            this.plusoneText = res.data.upsell.upsell_plusone_text;
            this.reviews = res.data.upsell.reviews ? res.data.upsell.reviews.slice(0, 2) : [];
            this.vimeo_id = res.data.upsell.upsell_video_id;

            this.description = res.data.upsell.description;

            this.imageUrl = res.data.upsell.image;
            this.gifImageUrl = res.data.upsell.gif_image;
            this.vimeoId = res.data.upsell.vimeo_id;
            this.videoFile = res.data.upsell.video_file;
          }

          this.priceFormatted = (this.upsellPrices["1"] && this.upsellPrices["1"].price_text) || "";
          this.price = (this.upsellPrices["1"] && this.upsellPrices["1"].price) || 0;
          this.finalPrice = (this.upsellPrices["1"] && this.upsellPrices["1"].price_text) || "";
          this.finalPricePure = (this.upsellPrices["1"] && this.upsellPrices["1"].price) || 0;
        }
      })
      .then(() => {
        this.isLoading = false;
      });
  },

  methods: {
    addProduct(quantity) {
      quantity = +quantity;

      this.finalPrice = (this.upsellPrices && this.upsellPrices[quantity] && this.upsellPrices[quantity].price_text) || "";
      this.finalPricePure = (this.upsellPrices && this.upsellPrices[quantity] && this.upsellPrices[quantity].price) || 0;

      this.addToCart(quantity);
    }
  }
};
</script>

<style lang="scss">
.step-plus-one {
  display: flex;
  min-height: 100vh;
  background-color: #333333;

  .step-content {
    max-width: 747px;
    margin: auto;
    box-shadow: 0px 0px 20px 10px rgba(16, 56, 107, 0.1);
    border-radius: 6px;
    padding: 30px 32px;
    background-color: #fff;
  }

  h1 {
    font-weight: bold;
    font-size: 31px;
    line-height: 30px;
    color: #333333;
  }

  h2 {
    font-weight: 400;
    font-size: 24px;
    line-height: 28px;
    margin: 30px 0;

    span {
      color: #f75353;
      font-weight: 500;
    }
  }

  h3 {
    font-size: 31px;
    line-height: 30px;
    font-weight: normal;
    color: #333333;
    text-align: center;
    margin-top: 50px;
    margin-bottom: 40px;
  }

  h4 {
    font-size: 20px;
    line-height: 30px;
    text-align: center;
    color: #626262;
    font-weight: normal;
  }

  .timer-title {
    font-weight: bold;
    font-size: 21px;
    line-height: 28px;
    color: #f75353;
  }

  .red-button {
    max-width: 470px;
  }

  .features-container {
    &__description {
      font-size: 24px;
      line-height: 28px;
      color: #333333;
    }
    &__image {
      max-width: 230px;
    }
  }

  @media screen and (max-width: 767px) {
    background-color: #fff;
    display: block;

    .step-content {
      box-shadow: none;
      padding: 15px;
    }

    h1 {
      font-size: 26px;
      line-height: 28px;
    }

    h3 {
      font-size: 21px;
      line-height: 30px;
    }

    h2 {
      font-size: 21px;
      line-height: 29px;
    }

    .timer-title {
      font-size: 16px;
      line-height: 28px;
    }

    .features-container {
      flex-direction: column-reverse;
    }
    .features-container__image {
      max-width: 100%;
    }
  }
}
</style>
